/**
 * Reminder wire ⇄ domain mappers.
 *
 * The notification-service `ReminderResponse` schema is a flat snake_case object
 * whose field names map 1:1 to the UI camelCase shape, so the generic deep
 * converter handles it without per-field fixups.
 */

import { toCamelDeep } from '@/services/http/caseMap'
import type { Reminder } from '@/types/reminder.types'

function unwrapList(raw: unknown): Record<string, unknown>[] {
  const arr = Array.isArray(raw) ? raw : ((raw as { items?: unknown[] })?.items ?? [])
  return arr as Record<string, unknown>[]
}

export function mapReminderFromApi(raw: Record<string, unknown>): Reminder {
  return toCamelDeep<Reminder>(raw)
}

export function mapReminderListFromApi(raw: unknown): Reminder[] {
  return unwrapList(raw).map(mapReminderFromApi)
}
